import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function IstorijaPrava() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Istorija prava" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Istorija prava</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Istorija prava
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Obavezan
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> Nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Predmet ima za cilj osposobljavanje studenta da razumije osnovne
                kategorije i pojmove istorijskog razvoja države i prava.
                Upoznavanje studenata sa osnovnim praktičnim saznanjima iz
                oblasti nacionalne istorije države i prava, sticanje znanja o
                nastanku prava sa nastankom države, sticanje znanja o razvitku
                pojedinih pravnih sistema i pravnih instituta, te sticanje
                znanja o vodećim i karakterističnim državama i njihovim pravima
                u različitim istorijskim periodima. Pored toga, predmet ima za
                cilj produbljivanje opšte i pravne kulture.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Sticanje osnovnih znanja o temeljima civilizacije, priprema
                studenta za izučavanje i razumijevanje pojmova i pravila
                savremenog prava, njegovih pojavnih oblika i budućih rješenja.
                Početno savladavanje pravne terminologije, razvijenje kod
                studenata specifičnog pravničkog načina razmišljanja, učeći ih
                da se na izvornom istorijsko-pravnom materijalu prilogođavaju
                delikatnoj vještini tumačenja pravnih normi. Zaokruživanje
                znanja koja pružaju opšte obrazovni predmeti, a posebno ovaj za
                koji je uveliko vezan pojam civilizacije, te produbljivanje
                opšte i pravne kulture. Nakon uspješno savladanog studijskog
                sadržaja predmeta Istorija prava, studenti će takođe biti
                osposobljeni da prepoznaju, označe, imenuju i izdvoje osnovne
                pojmove teorije prava i države. Takođe, studenti će biti
                osposobljeni da prepoznaju i objasne osnovne institute, načela,
                funkcije i vrijednosti prava te izdvoje i identifikuju glavne
                vrste izvora prava. Između ostalog, studenti će takođe biti u
                mogućnosti da imenuju i opišu osnovne tehnike prava.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                <strong>Teorijska nastava:</strong>
              </p>
              <ul className="values-section">
                <li>
                  Periodizacija istorije, prvobitna zajednica, brak, porodica i
                  religija, društvena organizacija i struktura
                </li>
                <li>
                  Robovlasništvo, osnovna obilježja Istočne despotije, Egipatska
                  i vavilonska društva, građansko i krivično pravo
                </li>
                <li>
                  Antičke države: Sparta i Atina, pravo Atinskih reformatora,
                  Helenizam
                </li>
                <li>
                  Vremensko trajanje i opšta obilježja feudalizma, feud –
                  feudalna hijerarhija, izvori srednjovjekovnog prava
                </li>
                <li>
                  Franačka i franačko pravo, izvori i grane, Vizantija i
                  vizantijsko pravo, Arapski kalifat i šerijetsko pravo
                </li>
                <li>
                  Novovjekovna Engleska, Francuska i SAD, Dušanov zakonik,
                  srednjovjekovno pravo u Zeti, Crnogorci pod turskom vlašću
                </li>
                <li>
                  Stvaranje države Petar I Zakonik opšti crnogorski i brdski
                  Stega, Petar II Projekat zakona o tečastva
                </li>
                <li>
                  Crna Gora za vrijeme Knjaza Danila, Danilov zakonik, Berlinski
                  kongres, Crna Gora za vrijeme Knjaza Nikole, reforme
                </li>
              </ul>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Osnovni oblici rada na predmetu su: Predavanja, vježbe,
                konsultacije, pismene provjere znanja (kolokvijumi),
                individualni rad studenata (seminarski i domaći radovi, referati
                i sl.), kao i grupno učestvovanje studenata na savlađivanju
                određenih tematskih jedinica.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P</td>
                    <td>
                      Predmet i značaj istorije prava, periodizacija istorije
                      države i prava
                    </td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P</td>
                    <td>Istorijsko – pravni izvori</td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P</td>
                    <td>
                      Pojam i izvori prvobitne zajednice, brak, religija i
                      društvena struktura u prvobitnoj zajednici
                    </td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P</td>
                    <td>Modaliteti nastanka prvih država</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P</td>
                    <td>
                      Država i pravo u robovlasničkom periodu, opšta obiležja
                      robovlasničke države i prava
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P</td>
                    <td>
                      Istočne despotije, izvori saznanja o državama starog
                      Istoka, egipatska i vavilonska država
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P</td>
                    <td>
                      Antičke države, stara Grčka, Spartanska i Atinska država,
                      Helenizam
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P</td>
                    <td>
                      Država i pravo u feudalnom periodu, feud i feudalna
                      hijerarhija
                    </td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P</td>
                    <td>
                      Franačko pravo, Vizantijsko pravo, Šerijatsko pravo,
                      Englesko pravo
                    </td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P</td>
                    <td>
                      Država i pravo u Buržoaskom periodu, liberalizam,
                      imperijalizam, kapitalizam
                    </td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P</td>
                    <td>Najznačajnije države novog vijeka</td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P</td>
                    <td>Nastanak SAD</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P</td>
                    <td>Osnovne karakteristike prava SAD</td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 3č / 2.15h</td>
                            <td>Ukupno: 60č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3č / 2.15h</td>
                            <td>Nastava + završni ispit: 45č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: č</td>
                            <td>Priprema i ovjera semestra: 4.5č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>
                              Priprema i polaganje popravnog ispita: 10.5č
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default IstorijaPrava;
